"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsRoutes = void 0;
const component_1 = require("@front/pages/settings/access/component");
const component_2 = require("@front/pages/settings/access/form/component");
const component_3 = require("@front/pages/user-group/list/component");
const component_4 = require("@front/pages/user-group/form/component");
const component_5 = require("@front/pages/settings/general/component");
const component_6 = require("@front/pages/reports/cost/component");
const component_7 = require("@front/pages/reports/cost/preview/component");
const component_8 = require("@front/pages/reports/shared/component");
const component_9 = require("@front/pages/style/list/component");
const component_10 = require("@front/pages/style/form/component");
const component_11 = require("@front/pages/style/preview/component");
const component_12 = require("@front/pages/account-grade/list/component");
const component_13 = require("@front/pages/account-grade/form/component");
const component_14 = require("@front/pages/account-grade/preview/component");
const backendImport_1 = require("@front/backendImport");
const component_15 = require("@front/pages/payment/list/component");
const component_16 = require("@front/pages/dblogs/list/component");
const component_17 = require("@front/pages/settings/whatsapp/component");
const component_18 = __importDefault(require("@front/pages/whatsapp-group/component"));
const component_19 = __importDefault(require("@front/pages/whatsapp-group/form/component"));
const component_20 = __importDefault(require("@front/pages/whatsapp-dm-contact/component"));
const component_21 = require("@front/pages/settings/whatsapp-settings/form/component");
const component_22 = require("@front/pages/settings/tutorial-statistics/component");
const component_23 = require("@front/pages/settings/tutorial-statistics/details/component");
exports.settingsRoutes = [
    {
        path: '/settings/tutorial-statistics',
        name: 'tutorial.statistics.title'.t(),
        component: component_22.TutorialStatisticsList,
        icon: 'pie-chart',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/settings/tutorial-statistics/:id',
        name: 'tutorial.statistics.details'.t(),
        component: component_23.TutorialStatisticsDetails,
        forceActive: '/settings/tutorial-statistics',
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.ai}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/settings/general',
        name: 'route.settings.general'.t(),
        component: component_5.GeneralSettings,
        icon: 'settings',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/settings/access',
        name: 'route.settings.access'.t(),
        component: component_1.AccessSettings,
        inMenu: true,
        icon: 'lock-open',
        acl: `${backendImport_1.ACL.aclResources.settings_access}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/reports/cost',
        name: 'route.reports.cost'.t(),
        component: component_6.CostReports,
        inMenu: true,
        icon: 'pie-chart',
        acl: `${backendImport_1.ACL.aclResources.reports}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/reports/cost/preview/:id',
        name: 'route.reports.cost.preview'.t(),
        component: component_7.CostPreview,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.reports}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/reports/shared',
        name: 'route.reports.shared'.t(),
        component: component_8.SharedReports,
        inMenu: true,
        icon: 'share-alt',
        acl: `${backendImport_1.ACL.aclResources.reports}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/user-group/list',
        name: 'route.userGroup.list'.t(),
        component: component_3.UserGroupList,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.user_group}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/user-group/create',
        name: 'route.userGroup.create'.t(),
        component: component_4.UserGroupForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.user_group}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/user-group/edit/:id',
        name: 'route.userGroup.edit'.t(),
        component: component_4.UserGroupForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.user_group}.${backendImport_1.ACL.aclActions.write}`
    },
    // Legacy ACL policy routes - redirect to user groups
    {
        path: '/settings/access/edit/:id',
        forceActive: '/settings/access',
        name: 'route.settings.accessEdit'.t(),
        component: component_2.AccessForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.settings_access}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/settings/access/add',
        forceActive: '/settings/access',
        name: 'route.settings.accessAdd'.t(),
        component: component_2.AccessForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.settings_access}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/settings/style/list',
        name: 'route.styles'.t(),
        component: component_9.StyleList,
        acl: `${backendImport_1.ACL.aclResources.settings_styles}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'magic-wand',
        inMenu: true
    },
    {
        path: '/settings/style/create',
        name: 'route.style.create'.t(),
        component: component_10.StyleForm,
        acl: `${backendImport_1.ACL.aclResources.settings_styles}.${backendImport_1.ACL.aclActions.write}`,
        inMenu: false
    },
    {
        path: '/settings/style/edit/:id',
        name: 'route.style.edit'.t(),
        component: component_10.StyleForm,
        acl: `${backendImport_1.ACL.aclResources.settings_styles}.${backendImport_1.ACL.aclActions.write}`,
        inMenu: false
    },
    {
        path: '/settings/style/preview/:id',
        name: 'route.style.preview'.t(),
        component: component_11.StylePreview,
        acl: `${backendImport_1.ACL.aclResources.settings_styles}.${backendImport_1.ACL.aclActions.read}`,
        inMenu: false
    },
    {
        path: '/settings/account-grade/list',
        name: 'route.accountGrade.list'.t(),
        component: component_12.AccountGradeList,
        inMenu: true,
        icon: 'graduation'
    },
    {
        path: '/settings/account-grade/form',
        name: 'route.accountGrade.create'.t(),
        component: component_13.AccountGradeForm,
        inMenu: false
    },
    {
        path: '/settings/account-grade/form/:id',
        name: 'route.accountGrade.edit'.t(),
        component: component_13.AccountGradeForm,
        inMenu: false
    },
    {
        path: '/settings/account-grade/preview/:id',
        name: 'route.accountGrade.preview'.t(),
        component: component_14.AccountGradePreview,
        inMenu: false
    },
    {
        path: '/payment/list',
        name: 'route.payment.list'.t(),
        component: component_15.PaymentList,
        acl: `${backendImport_1.ACL.aclResources.payment}.${backendImport_1.ACL.aclActions.read}`,
        icon: 'credit-card',
        inMenu: true
    },
    {
        path: '/dblogs/list',
        name: 'route.dblogs.list'.t(),
        component: component_16.DBLogsList,
        icon: 'layers',
        inMenu: true,
    },
    {
        path: '/settings/comms',
        name: 'route.settings.comms'.t(),
        component: component_17.WhatsAppSettings,
        icon: 'phone',
        inMenu: true,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/settings/comms/create',
        name: 'route.settings.comms.create'.t(),
        component: component_21.WhatsAppSettingsForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/settings/comms/edit/:id',
        name: 'route.settings.comms.edit'.t(),
        component: component_21.WhatsAppSettingsForm,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.write}`
    },
    {
        path: '/settings/comms/:phoneId',
        name: 'route.settings.comms.manage'.t(),
        component: component_17.WhatsAppSettings,
        inMenu: false,
        acl: `${backendImport_1.ACL.aclResources.settings_general}.${backendImport_1.ACL.aclActions.read}`
    },
    {
        path: '/settings/comms/group/:id',
        name: 'route.settings.comms.group'.t(),
        component: component_18.default,
        inMenu: false
    },
    {
        path: '/settings/comms/group/create/:settingsId',
        name: 'route.settings.comms.group.create'.t(),
        component: component_19.default,
        inMenu: false
    },
    {
        path: '/settings/comms/dm/:id',
        name: 'route.settings.comms.dm'.t(),
        component: component_20.default,
        inMenu: false
    },
];
